import React from "react";
import { motion } from "framer-motion";

import Eappartament from "../assets/images/eapartament.png";
import MarvelHub from "../assets/images/marvelhub.png";
import Interno from "../assets/images/interno.png";
import Forkify from "../assets/images/forkify.png";
import VushtrriaBasket from "../assets/images/vushtrriabasket.png";
import Farm from "../assets/images/zoufarmm.png";
import Jewelry from "../assets/images/jewelry.png";
import BookingKosova from "../assets/images/booking.png";
import HublotKosovo from "../assets/images/hublot.png";
import CyberSecurity from "../assets/images/cyber.png";
import NetflixAmarJanuzi from "../assets/images/netflix.png";
import EnesiSocialNetwork from "../assets/images/social.png";
import JusticeCounselors from "../assets/images/justice.png";
import VisitKosova from "../assets/images/visitKosovo.png";
import NasasEye from "../assets/images/nasaeye.png";
import CasaMia from "../assets/images/casamia.png";
import InnovativeHub from "../assets/images/hub.png";
import LibrariaDigjitale from "../assets/images/libraria.png";
import HealthLinker from "../assets/images/health.png";
import PllumiWaste from "../assets/images/waste.png";
import RecetaRamazan from "../assets/images/receta.png";

import UniqueAb from "../assets/images/projects/unique.png";
import Dollapi from "../assets/images/projects/dollapi.png";
import Anisa from "../assets/images/projects/anisa.png";
import Braha from "../assets/images/projects/braha.png";
import Avokate from "../assets/images/projects/avokate.png";
import BJ from "../assets/images/projects/bj.png";

const projectsData = [
  {
    title: "E-Apartament",
    description:
      "E-Aparament is a project created by our students where you can find and book apartaments online.",
    image: Eappartament,
    tags: ["HTML", "CSS", "JavaScript"],
    link: "https://e-apartament.netlify.app/",
  },
  {
    title: "MarvelHub",
    description:
      "Marvelhub is a project created by our students where you can find everything you need  to know about Marvel.",
    image: MarvelHub,
    tags: ["HTML", "CSS", "JavaScript"],
    link: "https://marvelhub.netlify.app/",
  },
  {
    title: "Interno",
    description:
      "Interno is a beatuful furnitures website where you can browse and create your interior.",
    image: Interno,
    tags: ["HTML", "CSS"],
    link: "https://ardbraha-interno.netlify.app/",
  },
  {
    title: "Forkify",
    description:
      "Forkify is a web where you can browse and create recipes so that you next cook will be easier.",
    image: Forkify,
    tags: ["HTML", "CSS", "JavaScript"],
    link: "https://ardbraha-forkify.netlify.app/",
  },
  {
    title: "Vushtrria Basket",
    description:
      "Our student created a website for our city basketball team where he showed his love for basket and coding.",
    image: VushtrriaBasket,
    tags: ["HTML", "CSS", "JavaScript"],
    link: "https://vushtrriabasket.netlify.app/",
  },
  {
    title: "Zou Farm",
    description:
      "Zou Farm is a website created by love from our students to a lovely farm.",
    image: Farm,
    tags: ["HTML", "CSS"],
    link: "https://zoufarmm.netlify.app/home",
  },
  {
    title: "Enesi Social Network",
    description:
      "Created by our students, Enesi Social Network is a dynamic platform designed to connect users, share updates, and foster community engagement with modern social features.",
    image: EnesiSocialNetwork,
    tags: ["Student Project", "Social Network", "Web"],
    link: "https://innovationacademy-ks.com/Social/",
  },
  {
    title: "Netflix Amar Januzi",
    description:
      "This student-built project replicates a streaming service interface, showcasing skills in UI design and media content organization, inspired by Netflix.",
    image: NetflixAmarJanuzi,
    tags: ["Student Project", "UI/UX", "Web Development"],
    link: "https://innovationacademy-ks.com/netflix/",
  },
  {
    title: "Cyber Security",
    description:
      "A student project focused on the fundamentals of cybersecurity, featuring educational content and practical examples to raise awareness about online safety.",
    image: CyberSecurity,
    tags: ["Student Project", "Cybersecurity", "Educational"],
    link: "https://innovationacademy-ks.com/laksh/cyber%20security/index.html",
  },
  {
    title: "Hublot Kosovo",
    description:
      "Designed by students, Hublot Kosovo is a stylish, responsive website showcasing luxury watch collections, blending elegant design with smooth navigation.",
    image: HublotKosovo,
    tags: ["Student Project", "E-commerce", "Web Design"],
    link: "https://innovationacademy-ks.com/hublotkosovo/",
  },
  {
    title: "Booking Kosova",
    description:
      "Booking Kosova is a student-developed online booking platform that helps users find and reserve accommodations across Kosovo with ease and reliability.",
    image: BookingKosova,
    tags: ["Project", "Booking ", "Web Development"],
    link: "https://innovationacademy-ks.com/bookingkosova/",
  },
  {
    title: "Jewelry",
    description:
      "A creative student project showcasing a jewelry store website featuring product displays, detailed descriptions, and a clean, elegant design.",
    image: Jewelry,
    tags: ["Student Project", "E-commerce", "Web Design"],
    link: "https://innovationacademy-ks.com/bizhuteri/",
  },
  {
    title: "Justice Counselors in Law",
    description:
      "Created by our students, this website provides comprehensive legal information and resources, designed to help users better understand their rights and access legal support.",
    image: JusticeCounselors,
    tags: ["Student Project", "Legal", "Informative"],
    link: "https://innovationacademy-ks.com/justice/",
  },
  {
    title: "Fall in Love with Kosovo",
    description:
      "A beautifully designed student project that promotes Kosovo's natural beauty, culture, and attractions to encourage tourism and local pride.",
    image: VisitKosova,
    tags: ["Student Project", "Tourism", "Informational"],
    link: "https://innovationacademy-ks.com/visitkosova/index.html",
  },
  {
    title: "Nasa's Eye",
    description:
      "Nasa’s Eye is a student-created space exploration website that showcases stunning NASA imagery and offers educational content about planets and astronomy.",
    image: NasasEye,
    tags: ["Student Project", "Astronomy", "Educational"],
    link: "https://na-sa.netlify.app",
  },
  {
    title: "Casa Mia Terrazza",
    description:
      "A modern restaurant website built by students, Casa Mia Terrazza features a menu, location details, and reservation options for a complete dining experience online.",
    image: CasaMia,
    tags: ["Student Project", "Restaurant", "Web Design"],
    link: "https://innovationacademy-ks.com/casa-mia-terrazza/index.html",
  },
  {
    title: "Innovative Hub",
    description:
      "Innovative Hub is a student-developed website that presents tech initiatives, workshops, and innovation-driven activities within a vibrant community.",
    image: InnovativeHub,
    tags: ["Student Project", "Innovation", "Community"],
    link: "http://innovationacademyhub.great-site.net/?i=1",
  },
  {
    title: "Libraria Digjitale",
    description:
      "Libraria Digjitale is a digital library project built by students, offering access to a collection of e-books and resources in an easy-to-use format.",
    image: LibrariaDigjitale,
    tags: ["Student Project", "Digital Library", "Education"],
    link: "https://innovationacademy-ks.com/digital-library/",
  },
  {
    title: "Health Linker",
    description:
      "Health Linker is a student-built healthcare website offering information about medical services, professionals, and health tips for users seeking care.",
    image: HealthLinker,
    tags: ["Student Project", "Health", "Informational"],
    link: "https://innovationacademy-ks.com/health-linker/html/services.html",
  },
  {
    title: "Pllumi Waste",
    description:
      "Pllumi Waste is an environmentally focused student project aimed at raising awareness about waste management and promoting sustainable practices.",
    image: PllumiWaste,
    tags: ["Student Project", "Environment", "Awareness"],
    link: "https://innovationacademy-ks.com/waste/",
  },

  {
    title: "Receta për Ramazan",
    description:
      "Receta për Ramazan is a cooking-focused website created by students, featuring traditional and modern recipes tailored for the month of Ramadan.",
    image: RecetaRamazan,
    tags: ["Student Project", "Cooking", "Ramadan"],
    link: "https://innovationacademy-ks.com/ramadan/",
  },
];

const clientProjects = [
  {
    title: "Avokate Fatmire Braha",
    description:
      "Avokate Fatmire Braha is a professional website built with Next.js, designed to present legal services and provide easy access to information for clients seeking legal assistance.",
    image: Avokate,
    tags: ["Next.js", "Law", "Professional Website"],
    link: "https://avokate.com/",
  },
  {
    title: "Unique AB",
    description:
      "Unique AB is an elegant e-commerce website focused on selling handmade bracelets. Built with WordPress, it provides a clean and user-friendly shopping experience for customers looking for unique, stylish accessories.",
    image: UniqueAb,
    tags: ["WordPress", "E-commerce", "Student Project"],
    link: "https://unique-ab.com/",
  },
  {
    title: "Dollapi",
    description:
      "Dollapi is a web platform where users can publish and sell their second-hand clothes. Developed using React.js and Django, it promotes sustainable fashion by making it easy to give pre-loved items a new home.",
    image: Dollapi,
    tags: ["React.JS", "Django"],
    link: "https://dollapi.online/",
  },
  {
    title: "Anisa Haroku",
    description:
      "Anisa Haroku is a stylish Shopify-based website dedicated to selling elegant dresses. It offers a modern, user-friendly shopping experience for fashion-forward customers.",
    image: Anisa,
    tags: ["Shopify", "E-commerce", "Fashion"],
    link: "https://anisaharoku.com/",
  },
  {
    title: "Braha Reifen & Autoservice",
    description:
      "Braha Reifen & Autoservice is a professional WordPress-based website for an auto service business offering tire sales, repairs, and comprehensive vehicle maintenance solutions.",
    image: Braha,
    tags: ["WordPress", "Auto Services", "Business"],
    link: "https://www.braha-reifen-autoservice.de/",
  },
  {
    title: "BJ Music Art",
    description:
      "BJ Music Art is a creative website built with HTML, CSS, and JavaScript, showcasing music services, performances, and artistic collaborations in a visually engaging way.",
    image: BJ,
    tags: ["HTML", "CSS", "JavaScript", "Music"],
    link: "https://www.bjmusicart.com/",
  },
];

export default function Projects({ category }) {
  return (
    <section className="projects">
      <div className="container">
        <div className="projects__grid">
          {category === "client"
            ? clientProjects.map((project, index) => (
                <motion.div
                  key={index}
                  className="project-card"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, ease: "easeOut" }}
                  viewport={{ once: true, amount: 0.2 }}
                >
                  <div className="project-card__image">
                    <img src={project.image} alt={project.title} />
                    <div className="project-card__overlay">
                      <div className="project-card__tags">
                        {project.tags.map((tag, tagIndex) => (
                          <span key={tagIndex} className="project-card__tag">
                            {tag}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="project-card__content">
                    <h3 className="project-card__title">{project.title}</h3>
                    <p className="project-card__description">
                      {project.description}
                    </p>
                    <a href={project.link} className="project-card__link">
                      View Project
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5 12H19M19 12L12 5M19 12L12 19"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </a>
                  </div>
                </motion.div>
              ))
            : projectsData.map((project, index) => (
                <motion.div
                  key={index}
                  className="project-card"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, ease: "easeOut" }}
                  viewport={{ once: true, amount: 0.2 }}
                >
                  <div className="project-card__image">
                    <img src={project.image} alt={project.title} />
                    <div className="project-card__overlay">
                      <div className="project-card__tags">
                        {project.tags.map((tag, tagIndex) => (
                          <span key={tagIndex} className="project-card__tag">
                            {tag}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="project-card__content">
                    <h3 className="project-card__title">{project.title}</h3>
                    <p className="project-card__description">
                      {project.description}
                    </p>
                    <a href={project.link} className="project-card__link">
                      View Project
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5 12H19M19 12L12 5M19 12L12 19"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </a>
                  </div>
                </motion.div>
              ))}
        </div>
      </div>
    </section>
  );
}
